import React, { Component } from "react";
import MyNavbar from "../../components/Navbar/MyNavbar";
import UpdateClient from "../../components/client/ClientRegistration/UpdateClient";

export default class UpdateClientPage extends Component {
  render() {
    return (
      <div>
        <MyNavbar />
        <UpdateClient />
      </div>
    );
  }
}
